<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <template v-slot:activator="{ on }">
        <v-btn icon flat>
          <v-icon color="grey darken-1" @click="dialog = true">mdi-delete</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-card-title
          class="headline"
          primary-title
        >
          <span>
            Atenção
          </span>
        </v-card-title>

        <v-card-text>
          Deseja remover o despacho '{{ dispatch.title }}'? Essa ação não poderá ser desfeita
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            flat
            @click="dialog = false"
            :disabled="loading"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="accent"
            flat
            :loading="loading"
            @click="destroy()"
          >
            Remover
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import DispatchService from "@/services/system/DispatchService";

export default {
  name: 'DestroyDispatch',
  props: ['dispatch'],
  data() {
    return {
      dialog: false,
      loading: false,
    }
  },
  methods: {
    destroy() {
      this.loading = true;
      DispatchService
        .destroy(this.dispatch.id)
        .then((res) => {
          this.$emit('reloadPage');
          this.$store.dispatch('toggleSnackbar', {
            show: true,
            color: 'success',
            message: 'Despacho removido com Sucesso',
            button: {show: true, text: 'Fechar', message: ''},
            timeout: 6000,
          });
        })
        .catch((err) => {

        })
        .finally(() => {
          this.loading = false;
        })
    }
  },
};
</script>

<style scoped lang="scss">
  .v-card__title {
    background-color: #4185f4;

    span {
      color: white;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/settings/dispatches/DestroyDispatch.vue